import React from 'react';
import { BRAND, SUPPORT_EMAIL } from '../data/content';
export function Footer() {
  return <footer className="border-t-2 border-volt/25 bg-carbon" data-id="element-78" data-mp="3gfsoch60l2p3">
      <div className="mx-auto max-w-3xl px-3 py-7 text-center sm:px-6" data-id="element-79" data-mp="3ghc486nrdbqc">
        <p className="text-[0.72rem] font-extrabold uppercase tracking-[0.12em] text-volt sm:text-xs" data-id="element-80" data-mp="32pffmclatjyp">
          © 2026 {BRAND} — Todos los Derechos Reservados.
        </p>
        <p className="mt-3 text-[0.68rem] leading-snug text-steel-dark sm:text-[0.72rem]" data-id="element-81" data-mp="3uesclnpm7fkq">
          Sistema Electricista Domiciliario Desde Cero™ es un producto
          educativo de {BRAND}. No sustituye formación profesional, práctica
          supervisada, normativa eléctrica, evaluación de riesgos, licencias,
          matrículas, certificaciones, permisos ni el criterio de un
          profesional habilitado. La electricidad puede provocar electrocución,
          quemaduras, incendios, lesiones graves o muerte.
        </p>
        <p className="mt-3 text-[0.72rem] text-steel sm:text-xs" data-id="element-82" data-mp="2ezl35w4w5xez">
          Soporte:{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-volt underline underline-offset-2" data-id="element-83" data-mp="3la28msb12zu6">
            {SUPPORT_EMAIL}
          </a>
        </p>
        <p className="mt-2 text-[0.7rem] text-steel-dark sm:text-xs" data-id="element-84" data-mp="3v9b09eif82dd">
          Términos y Condiciones • Política de Privacidad • Contacto
        </p>
      </div>
    </footer>;
}